import { useOrganization } from "@clerk/react";

export interface SiteAdmin {
  userId: string;
  name: string;
  imageUrl?: string;
}

// Mirrors app.normalize_unit_role() in
// scoutingops-hub/supabase/migrations/20260630120000_create_unit_security_model.sql
// for the Clerk-role half only — deliberately does NOT also query
// unit_member_roles for a DB-side admin override the way an earlier pass
// of this Health check did, since that duplicated logic that belongs in
// @scoutingops/security, not hand-rolled here again (see
// docs/site-builder-overhaul.md's Phase A). This will under-count a unit
// that granted someone admin only via a unit_member_roles override without
// also making them a Clerk org:admin — an accepted narrower scope for now.
function normalizesToAdmin(rawRole: string | null | undefined): boolean {
  const role = (rawRole ?? "").toLowerCase();
  return role === "admin" || role === "org:admin" || role === "owner" || role === "super_admin" || role.includes("admin");
}

export function useSiteAdmins(): { admins: SiteAdmin[]; isLoading: boolean } {
  const { memberships, isLoaded } = useOrganization({ memberships: { pageSize: 100 } });

  const admins: SiteAdmin[] = (memberships?.data ?? [])
    .filter((membership) => normalizesToAdmin(membership.role))
    .map((membership) => {
      const userId = membership.publicUserData?.userId ?? membership.id;
      const name =
        [membership.publicUserData?.firstName, membership.publicUserData?.lastName].filter(Boolean).join(" ") ||
        membership.publicUserData?.identifier ||
        userId;
      return { userId, name, imageUrl: membership.publicUserData?.imageUrl };
    });

  return { admins, isLoading: !isLoaded };
}
